<template>
  <v-row>
    <v-col cols="12">
      <promotions-table />
    </v-col>
  </v-row>
</template>

<script>
import PromotionsTable from 'Components/Promo/list/PromotionsList'

export default {
  name: 'PromoListView',
  data: () => ({
    loading: true
  }),
  components: {
    PromotionsTable
  },
}
</script>
